module.exports = __webpack_public_path__ + "static/img/M-500-WHITE.5f3a999.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/M-500-WHITE.png
// module id = ufEJ
// module chunks = 0